import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import strings from '../../strings/strings.json'
import { checkLicense, setLicense, updateAvsList } from 'api/api_service';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import { useHistory } from 'react-router-dom';
import InputMask from "react-input-mask";
import { ISystemInfo } from 'types';
import moment from 'moment-jalaali';

export default function License() {
    const dispatch = useDispatch();
    const history = useHistory()
    const [value, setValue] = useState('')
    const [data, setData] = useState<ISystemInfo>()

    useEffect(() => {
        checkLicense()
            .then(res => {
                if (res.status === 200) {
                    if (res.data.data) {
                        setData(res.data.data)
                    } else {
                        dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.license_error}` }));
                    }
                }
            })
    }, [])

    const onChange = (e: any) => {
        setValue((e.target.value).toUpperCase())
    };

    const confirmHandler = () => {
        let newValue = value.replace(/\s/g, '')
        if (newValue && newValue.length === 10) {
            setLicense({
                "serial": newValue
            })
                .then(res => {
                    if (res.data.data) {
                        updateAvsList()
                        dispatch(showSnackbar({ "open": true, severity: "success", msg: `${strings.public_operationDone}` }));
                        history.push('/')
                    }
                    else
                        dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.license_wrong}` }));

                })
                .catch(err => {
                    if (err.response.data.error_code === 96) {
                      dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
                    }  else {
                       dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.license_wrong }));
                   }              	
               })
        }
        else
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.license_invalid}` }));
    }


    const renderData = (title: string, subTitle: string) => {
        return (
            <div className='flex justify-center flex-col items-center'>
                <span className='font-bold primary_text_color'>{title}</span>
                <span className='secondry_text_color'>{subTitle}</span>
            </div>
        )
    }

    return (

        <div className='flex items-center justify-center flex-col mt-32'>
            <span className='primary_text_color font-bold text-lg'>{strings.settings_license}</span>
            <span className='secondry_text_color'>{strings.settings_licenseSub}</span>
            <InputMask
                className='VazirEng border-2 border-blue-400 text-center primary_text_color rounded-lg font-bold py-1 mt-3'
                dir='ltr'
                maskPlaceholder="_"
                mask="* * * * * * * * * *"
                placeholder='_ _ _ _ _ _ _ _ _'
                alwaysShowMask={true}
                value={value}
                onChange={onChange}
            />
            <div className='mt-5'>
                <button
                    disabled={value ? false : true}
                    className={`${!value ? 'cursor-not-allowed' : 'cursor-pointer'} text-white w-28 rounded-full px-8 py-2 primary_bg_color text-xs`}
                    onClick={() => confirmHandler()}
                >
                    {strings.public_confirm}
                </button>
            </div>
            {
                data !== undefined &&
                <div className='grid grid-cols-4 w-full text-center justify-around border border-gray-100 rounded-lg py-5 mt-10'>
                    <div className='border-l md:col-span-1 sm:col-span-3 sm:border-l-0 xs:col-span-5 xs:border-l-0'>{renderData(strings.home_softwareVersion, (data !== undefined && data) ? data.version : '-')}</div>
                    <div className='border-l md:col-span-1 sm:col-span-2 sm:border-l-0 xs:col-span-5 xs:mt-5'>{renderData(strings.home_expireLicense, (data !== undefined && data) ? moment(data.expire_time_str).format('jYYYY/jM/jD') : '-')}</div>
                    <div className='border-l md:col-span-1 sm:col-span-3 sm:border-l-0 sm:mt-5 xs:col-span-5 xs:mt-5 xs:border-l-0'>{renderData(strings.home_productName, (data !== undefined && data) ? data.product : '-')}</div>
                    <div className='md:col-span-1 sm:col-span-2 sm:border-l-0 sm:mt-5 xs:col-span-5 xs:mt-5 xs:border-l-0'>{renderData(strings.home_plan, (data !== undefined && data) ? data.plan : '-')}</div>
                </div>
            }
        </div>
    )
}
